import { statement } from "@babel/template";
import Card from '@material-ui/core/Card'
import React, { Component } from 'react'
import TextField from '@material-ui/core/TextField'
import Button from '@material-ui/Core/Button'
import Select from '@material-ui/Core/Select'
import { CardHeader, CardActionArea, CardActions, Grid } from "@material-ui/Core";
import NavigateNext from '@material-ui/icons/NavigateNext'
import NavigateBeforeIcon from '@material-ui/icons/NavigateBefore'
import ButtonGroup from '@material-ui/Core/ButtonGroup'

class PersonalInfo extends Component {
    constructor(props){
        super(props);
        this.state = {
            firstname: "",
            lastname: "",
            email: "",
            phone: "",
            mobilephone: "",
            emailError: false,
            lastnameError: false,
            firstnameError: false,
            phoneError: false,
            mobilephoneError: false,
            isLoading: false
        }
        this.handleFirstNameChange = this.handleFirstNameChange.bind(this);
        this.handleLastNameChange = this.handleLastNameChange.bind(this);
        this.handleEmailChange = this.handleEmailChange.bind(this);
        this.handlePhoneChange = this.handlePhoneChange.bind(this);
        this.handleMobilePhoneChange = this.handleMobilePhoneChange.bind(this);

        this.handleSubmit = this.handleSubmit.bind(this);
    }

    handleFirstNameChange(event) {
        if(!event.target.value.match(/[!@$%^&*()\/\\,?":{}|<>]/g)){
            this.setState({ firstname: event.target.value, firstnameError: false})
        } else {
            this.setState({firstname: event.target.value, firstnameError:true})
        }
    }

    handleLastNameChange(event) {
        if(!event.target.value.match(/[!@$%^&*()\/\\,?":{}|<>]/g)){
            this.setState({ lastname: event.target.value, lastnameError:false})
        } else {
            this.setState({lastnameError:true})
        }
        
    }

    handleEmailChange = (event) => {
        this.setState({ email: event.target.value})
    }

    handlePhoneChange = (event) => {
        
        console.log("phone change: " + event.target.value)
        this.setState({ phone: event.target.value})
    }

    handleMobilePhoneChange = (event) => {
        this.setState({ mobilephone: event.target.value})
    }


    validateEmail = (event) => {
        var error = /^[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/.test(event.target.value);
        this.setState({
            emailError: !error
        })
    }

    validateFirstName = (event) => {
        if(this.state.firstname.length && this.state.firstname.match(/^[^a-zA-Z0-9]+$/)){
            this.setState({
                firstnameError: true
            })
        }
    }

    validateLastName = (event) => {
        if(this.state.lastname.length && this.state.lastname.match(/^[^a-zA-Z0-9]+$/)){
            this.setState({
                lastnameError: true
            })
        }
    }

    handleSubmit(event){
        console.log("submit: ", this.state)
        let hasErrors=false
        if(!this.state.email.length || this.state.emailError){
            hasErrors = true
            this.setState({
                emailError: true
            })
        }
        if(this.state.firstnameError || (this.props.viewInstance.FirstNameVisible == "1" && (!this.state.firstname.length && this.props.viewInstance.FirstNameRequired == "1"))){
            hasErrors = true
            this.setState({
                firstnameError: true
            })
        }
        if(this.state.firstname.length && this.state.firstname.match(/^[^a-zA-Z0-9]+$/)){
            hasErrors = true
            this.setState({
                firstnameError: true
            })
        }
        if(this.state.lastnameError || (this.props.viewInstance.LastNameVisible == "1" && (!this.state.lastname.length && this.props.viewInstance.LastNameRequired == "1"))){
            hasErrors = true
            this.setState({
                lastnameError: true
            })
        }
        if(this.state.lastname.length && this.state.lastname.match(/^[^a-zA-Z0-9]+$/)){
            hasErrors = true
            this.setState({
                lastnameError: true
            })
        }
        if(this.props.viewInstance.HomePhoneVisible == "1" && (!this.state.phone.length && this.props.viewInstance.HomePhoneRequired == "1")){
            hasErrors = true
            this.setState({
                phoneError: true
            })
        }
        if(this.props.viewInstance.MobilePhoneVisible == "1" && !this.state.mobilephone.length && this.props.viewInstance.MobilePhoneRequired == "1"){
            hasErrors = true
            this.setState({
                mobilephoneError: true
            })
        }
        console.log("errors: ", this.state)

        
        if(!hasErrors){ 
            this.props.updateUserEmail(this.state.email)
            this.setState({
                isLoading: true
            })
            var firstname = this.state.firstname.length ? this.state.firstname : "~_~";
            var lastname = this.state.lastname.length ? this.state.lastname : "~_~";
            
            fetch('../../WsWebServicePlatform/Participant/Update',
            {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    "ParamData": {
                        "AuthToken": this.props.authtoken,
                        "ParticipantGuid": this.props.participantguid,
                        "GroupGuid": this.props.groupguid,
                        "FirstName": firstname,
                        "LastName": lastname,
                        "Email": this.state.email
                    }
                })
            })
            .then(results=>results.json())
            .then(results=>{
                //if(results.Success){
                    if(this.props.skipAddress){
                        this.props.showresults();
                    } else {

                        this.props.showAddressInfoCard();
                    }
                    if(this.state.phone.length){
                        fetch('../../WsWebServicePlatform/Participant/Phone/Create/' +
                        this.props.authtoken + '/' +
                        this.props.participantguid + '/' +
                        'C05F6C51-5992-477C-BD94-7EE28E7CD4BD/' +
                        '1' + '/' +
                        this.state.phone	+ '/',
                        {
                            method: 'POST',
                            headers: {
                                'Accept': 'application/json',
                                'Content-Type': 'application/json'
                            },
                            body: {
            
                            }
                        })
                    }
                    if(this.state.mobilephone.length){
                        fetch('../../WsWebServicePlatform/Participant/Phone/Create/' +
                        this.props.authtoken + '/' +
                        this.props.participantguid + '/' +
                        '9232B9CA-5C20-40C2-9190-25E302FDC0BE/' +
                        '2' + '/' +
                        this.state.mobilephone + '/',
                        {
                            method: 'POST',
                            headers: {
                                'Accept': 'application/json',
                                'Content-Type': 'application/json'
                            },
                            body: {
            
                            }
                        })
                    }
                    
                //}
            })
        }
        
        
    }

    render() {
        var icon = <NavigateNext />
        if(this.state.isLoading){
            icon = <img src="loading.gif" width='20px' style={{marginLeft: '4px'}}/>
        }
        var firstname, lastname, homephone, mobilephone
        if(this.props.viewInstance.FirstNameVisible == "1"){
            firstname = <TextField
                            id="first-name"
                            label={this.props.viewInstance.FirstNameLabel}
                            autoComplete="given-name"
                            variant="outlined"
                            margin="normal"
                            required={this.props.viewInstance.FirstNameRequired == "1"}
                            value={this.state.firstname}
                            onChange={this.handleFirstNameChange}
                            error={this.state.firstnameError}
                            onBlur={this.validateFirstName}
                        />
        }

        if(this.props.viewInstance.LastNameVisible == "1"){
            lastname = <TextField
                            id="last-name"    
                            label={this.props.viewInstance.LastNameLabel}
                            autoComplete="family-name"
                            variant="outlined"
                            margin="normal"
                            required={this.props.viewInstance.LastNameRequired == "1"}
                            visible={this.props.viewInstance.LastNameVisible != "0"}
                            value={this.state.lastname}
                            onChange={this.handleLastNameChange} 
                            error={this.state.lastnameError}
                            onBlur={this.validateLastName}
                        />
        }

        if (this.props.viewInstance.HomePhoneVisible == "1"){
            homephone = <TextField
                            id="phone"
                            type="tel"
                            name="phone"
                            autocomplete="tel"
                            variant="outlined"
                            margin="normal"
                            label={this.props.viewInstance.HomePhonePrompt}
                            required={this.props.viewInstance.HomePhoneRequired == "1"}
                            onChange={this.handlePhoneChange}
                            value={this.state.phone}
                            error={this.state.phoneError}
                        >
                        </TextField>
        }
        if (this.props.viewInstance.MobilePhoneVisible == "1") {
            mobilephone = <TextField
                            id="mobilephone"
                            type="tel"
                            name="phone"
                            autocomplete="tel"
                            variant="outlined"
                            margin="normal"
                            label={this.props.viewInstance.MobilePhonePrompt}
                            required={this.props.viewInstance.MobilePhoneRequired == "1"}
                            onChange={this.handleMobilePhoneChange}
                            value={this.state.mobilephone}
                            error={this.state.mobilephoneError}
                        ></TextField>
        }
        return (
            
            <Card raised="true">
                <CardHeader title={this.props.viewInstance.CardTitle} />
                <CardActions style={{paddingLeft:'18px', paddingRight:'18px'}}>
                    <Grid container
                        direction="column"
                        justify="space-around"
                        alignItems="stretch">
                        {firstname}
                        {lastname}
                        <TextField
                            id="email"
                            label={this.props.viewInstance.EmailLabel}
                            type="email"
                            name="email"
                            autoComplete="email"
                            variant="outlined"
                            margin="normal"    
                            value={this.state.email}
                            onChange={this.handleEmailChange}
                            required="true"
                            error={this.state.emailError}
                            onBlur={this.validateEmail} 
                        />
                        
                        {homephone}
                        {mobilephone}
                            
                        
                        <ButtonGroup style={{margin:'10px'}}>
                            <Button 
                                style={{fontSize: '.8em', width:'50%'}}
                                onClick={this.props.showQuiz}>
                                    <NavigateBeforeIcon/>{this.props.viewInstance.ButtonBackToQuiz}</Button>
                            <Button 
                            variant="contained"
                            color="primary"
                            style={{fontSize: '1em', width:'50%'}}
                            onClick={this.handleSubmit}>{this.props.viewInstance.ButtonLabel} {icon}</Button> 
                        </ButtonGroup>
                        
                    </Grid>
                    
                </CardActions>
            </Card>
        )
    }
}

export default PersonalInfo;